import React from "react";
import styles from "./index.module.scss";
import { ReactComponent as _NextIcon } from "./assets/arrow_next.svg";
import { ReactComponent as _PrevIcon } from "./assets/arrow_prev.svg";

export const PrevIcon = _PrevIcon;
export const NextIcon = _NextIcon;

export default function BlogButton({ children, ...rest }) {
  return (
    <button className={styles.btn} {...rest}>
      {children}
    </button>
  );
}
